import React, { Fragment, useState } from "react";
import DashobardIcon from "../assets/icons/Dashboard.svg";
import SignOutIcon from "../assets/icons/SignOutIcon.svg";
import { Link } from "react-router-dom";
import { snackbar } from "@mobiscroll/react";
import { signOut } from "aws-amplify/auth";
import { FaUser } from "react-icons/fa";

const HeaderTop = ({ handleSidebar, searchBar, TimeBar }) => {

  const getRole = () => {
    switch (sessionStorage.getItem("userRole")) {
      case "SuperAdmin": return "Super Admin";
      case "SubAdmin": return "Sub Admin";
      case "AccountManager": return "Account Manager";
      case "Doctor": return "Doctor";
      default: return "Unknown Role";
    }
  }

  async function WebSignOut() {
    try {
      signOut()
        .then(() => {
          snackbar({
            message: "You have been logged out",
            color: "danger",
          });
        })
        .catch(() => {
          snackbar({
            message: "Unable to logout, Please Refresh.",
            color: "danger",
          });
        });
      localStorage.clear();
      sessionStorage.clear();
      window.location = "/";
    } catch (error) {
      console.error("error signing out: ", error);
    }
  }
  return (
    <Fragment>
      <nav className="navbar navbar-expand-lg navbar-transparent fixed-top navbar-fixed-top">

        <div className="d-md-flex docg-navbar-container" style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          width: "100%",
          padding: "0 1rem",
          justifyContent: "space-between",
          flexWrap: "wrap"
        }}>
          <button type="button" className="btn btn-link" onClick={() => { handleSidebar(false); }}>
            <img src={DashobardIcon} alt="toggle-sidebar" />
          </button>

          <div style={{ flex: 1 }} />    {/* Add spacer */}

          <div className="docg-role-badge" style={{
            border: "2px solid #c06c84",
            padding: "4px 12px",
            fontSize: "0.9rem",
            borderRadius: "14px",
            fontWeight: "600",
            textAlign: "center",
            color: "#c06c84",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            whiteSpace: "nowrap"
          }}>
            <FaUser
              style={{ marginRight: "12px", color: "#c06c84", height: "1rem", }}
            />
            {getRole()}
          </div>

          <div style={{ flex: 1 }} />    {/*  Add spacer */}

          <div className="docg-top-bar-left  jc-sb">
            <ul className="navbar-nav  align-items-center">
              <li className="nav-item">
                <button onClick={WebSignOut} title="Logout" className="nav-link">
                  <img src={SignOutIcon} alt="" />
                </button>
              </li>
            </ul>
          </div>

        </div>
      </nav>
    </Fragment>
  );
};

export default HeaderTop;